module.exports = __webpack_public_path__ + "img/instagram-logo-32.9f7c8e4d.svg";